import React, { useState } from "react";
import Down from "../../assets/svg/down_arrow.svg";
import "./Select.css";

const Select = ({ options, onChange, placeholder, isMulti = false }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    if (isMulti) {
      setSelectedOptions([...selectedOptions, option]);
      onChange([...selectedOptions, option]);
    } else {
      setSelectedOptions([option]);
      onChange(option);
    }
    setIsOpen(false);
  };

  const handleRemoveOption = (option) => {
    const updatedOptions = selectedOptions.filter(
      (selected) => selected.value !== option.value
    );
    setSelectedOptions(updatedOptions);
    onChange(updatedOptions);
  };

  const availableOptions = options.filter(
    (option) =>
      !selectedOptions.some((selected) => selected.value === option.value)
  );

  return (
    <div className={`custom-select-container ${isMulti ? 'multi-select' : ''}`}>
      <div className="select-dropdown" onClick={toggleDropdown}>
        <span className="select-icon">
          <img src={Down} alt="icon" />
        </span>
      </div>
      <div className="selected-options">
        {selectedOptions.length === 0 && !isOpen && (
          <div className="placeholder">{placeholder}</div>
        )}
        {selectedOptions.map((option) => (
          <div key={option.value} className={`selected-option ${isMulti ? 'multi-selected-option' : 'single-selected-option'}`}>
            {option.label}  
          
              <span 
                className="remove-button" 
                onClick={() => handleRemoveOption(option)}
              >
                &times;
              </span>
          </div>
        ))}
      </div>

      {isOpen && (
        <div className="options-list">
          {availableOptions.map((option) => (
            <div
              key={option.value}
              className="option-item"
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Select;
